export default __webpack_public_path__ + "static/media/yd-bill.533daaba.png";